export const ACTIVITY_TYPES = {
  file: 'file',
  order: 'order',
  note: 'note',
  user: 'user',
  alert: 'alert',
  status: 'status',
  debug: 'debug',
};